import { Injectable } from '@angular/core';
import {webapi} from '../../shared/my-constants';
import {Headers, Http} from '@angular/http';

@Injectable()
export class PayoutsService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private AddRecord = webapi + 'trn_payout/create';
  private ArrayList = webapi + 'trn_payout/list/?';

  constructor(
    private http: Http
  ) { }

  addRecordService(model: any) {
     console.log('add record in service file::',model);
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getallAccountiglist(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    console.log('data in service get request::', 'current page:', currentPage, 'size::', size, 'qstring::', qString, 'sort::', sort, 'col:::', col);
    return this.http.get(this.ArrayList + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
}
  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/accounting/payouts/payouts.service.ts